import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(false);

  async function login(email, password) {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  }

  function hasPermission(permission) {
    if (!user) return false;
    const rolePerms = {
      super_admin: ['view', 'scan', 'approve', 'edit', 'admin'],
      restaurant_admin: ['view', 'scan', 'approve', 'edit', 'admin'],
      gm: ['view', 'approve'],
      chef: ['view', 'approve'],
      supplies: ['view', 'approve'],
      bartender: ['view'],
      staff: ['scan'],
    };
    const perms = [...(rolePerms[user.role] || []), ...(user.permissions || [])];
    return perms.includes(permission);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
